<template>
  <div>
    <div v-for="(ord,index) in subOrderDataList" :key="ord.orderId">
      <van-cell :title="`子订单-${index+1}`"></van-cell>
      <van-card v-for="g in ord.goodsList" :key="g.name"
                :desc="`规格：${Array.isArray(g.spec) ? g.spec.join(',') : ''}`"
                :num="g.count"
                :price="g.price | money"
                :thumb="g.img"
                :title="g.name"
                currency=""
      />
      <van-cell v-if="ord.statusExpress>0" :is-link="ord.statusExpress===2" icon="logistics" style="font-size: 12px"
                @click="showExpressInfo(ord.expressInfo)">
        <template #title>
          <span v-if="ord.statusExpress===1">待发货</span>
          <span v-else-if="ord.statusExpress===2">已发货</span>
        </template>
        <span v-if="ord.statusExpress===2">查看详情</span>
      </van-cell>
    </div>
  </div>
</template>

<script>
import {getOrderAndSubById} from "@/api/goods-api";
import ExpressInfo from "@/views/user-center/order-list/goods/express-info";

export default {
  name: "sub-order-list",
  components: {ExpressInfo},
  props: {
    orderId: {require: true, type: String}
  },
  watch: {
    orderId(v) {
      getOrderAndSubById(this.orderId).then(res => {
        this.subOrderDataList = res.data;
      })
    }
  },
  data() {
    return {
      subOrderDataList: [],
    }
  },
  created() {
    getOrderAndSubById(this.orderId).then(res => {
      this.subOrderDataList = res.data;
    })
  },
  methods: {
    showExpressInfo(info) {
      if (info) {
        this.$emit('showExpInfo', info);
      }
    },
  }
}
</script>

<style scoped>

</style>
